// LoginForm.tsx
import React, { useState } from "react";
import "./css/LoginPage.scss";
import logo from "../../../assets/images/adddlogo.png";

interface LoginFormProps {
  onSubmit: (credentials: { email: string; password: string; }) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSubmit }) => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorStatus, setErrorStatus] = useState<boolean>(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (email === "") {
      setErrorStatus(true);
      setErrorMessage("아이디(이메일)는 필수 입력사항입니다.");
      return;
    } else if (password === "") {
      setErrorStatus(true);
      setErrorMessage("비밀번호는 필수 입력사항입니다.");
      return;
    }
    setErrorStatus(false);
    setErrorMessage("");
    onSubmit({ email, password });
  };

  return (
    <main className="login-page">
      <section className="login-hero" aria-label="addd AI 데이터 플랫폼 소개">
        <div className="login-hero__grid" aria-hidden="true" />
        <div className="login-hero__top">
          <img src={logo} alt="addd" />
          <span>AI DATA OPERATIONS</span>
        </div>
        <div className="login-hero__copy">
          <span className="login-hero__eyebrow">URBAN INTELLIGENCE</span>
          <h1>데이터를 읽고,<br />결정을 <em>연결합니다.</em></h1>
          <p>현실 세계의 데이터를 운영 가능한 인사이트로 전환하는 addd AI 통합 관리 플랫폼</p>
        </div>
        <div className="login-hero__meta">
          <span><i />REAL-TIME DATA</span>
          <span><i />AI OPERATIONS</span>
          <span><i />MEDIA INTELLIGENCE</span>
        </div>
      </section>

      <section className="login-panel">
        <form className="loginForm" onSubmit={handleSubmit}>
          <div className="loginFormTitle">
            <span>WELCOME BACK</span>
            <h2>AI 운영 콘솔</h2>
            <p>계정 정보를 입력해 워크스페이스에 접속하세요.</p>
          </div>

          <label htmlFor="login-email">이메일</label>
          <input
            id="login-email"
            type="email"
            placeholder="name@addd.co.kr"
            value={email}
            autoComplete="username"
            onChange={(e) => setEmail(e.target.value)}
          />
          <label htmlFor="login-password">비밀번호</label>
          <input
            id="login-password"
            type="password"
            placeholder="비밀번호를 입력하세요"
            value={password}
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
          {errorStatus && <span className="errorMessage" role="alert">{errorMessage}</span>}
          <button type="submit">로그인 <span aria-hidden="true">↗</span></button>
          <small>AUTHORIZED USERS ONLY · ADDD AI PLATFORM</small>
        </form>
      </section>
    </main>
  );
};

export default LoginForm;
